import styled from '@emotion/styled/macro';
import vars from '../../variables';
import { motion } from 'framer-motion';

export const SecondaryWrapper = styled(motion.div)`
  display: block;
  position: fixed;
  top: 0;
  bottom: ${vars.primaryNavHeight};
  left: 0;
  right: 0;
  background-color: white;
  overflow-y: auto;
  z-index: 9;
  @media screen and (min-width: ${vars.breakPointTablet}) {
    display: none;
  }
`;

export const SecondaryWrapperNav = styled.div`
  background-color: ${vars.coreDarkGrey};
  height: 58px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${vars.spacingM};
  padding-right: 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.15);
  z-index: 9;
`;

export const Align = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Heading = styled.div`
  font-weight: ${vars.fontWeightBold};
  font-size: 2.4rem;
  margin-top: ${vars.primaryNavHeight};
  padding: ${vars.spacingL} ${vars.spacingM};
  background-color: ${vars.greyHavens};
  border-bottom: 1px solid ${vars.lightGrey};
`;

export const IconWrapper = styled.div`
  background-color: white;
  height: 58px;
  width: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BackCopy = styled.p`
  font-weight: ${vars.fontWeightMedium};
  font-size: 1.8rem;
  color: white;
  margin-left: ${vars.spacingM};
`;
